module.exports = __webpack_public_path__ + "img/oem6.30fb6754.png";